import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface ReportDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  isDeleting: boolean;
  onConfirm: () => void;
}

export const ReportDeleteDialog: React.FC<ReportDeleteDialogProps> = ({
  open,
  onOpenChange,
  title,
  isDeleting,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-[425px] w-[calc(100%-2rem)]">
      <DialogHeader>
        <DialogTitle>Excluir Report</DialogTitle>
        <DialogDescription>
          Tem certeza que deseja excluir o report &quot;{title}&quot;? Esta ação não pode ser
          desfeita.
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="flex justify-end gap-2">
        <Button
          variant="outline"
          type="button"
          onClick={() => onOpenChange(false)}
          disabled={isDeleting}
        >
          Cancelar
        </Button>
        <Button
          type="button"
          onClick={onConfirm}
          disabled={isDeleting}
          className="bg-red-600 hover:bg-red-700 text-white"
        >
          {isDeleting ? 'Excluindo...' : 'Excluir'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
